export default __webpack_public_path__ + "static/media/43BD9790-DAAB-4191-B758-BE6075BD74AE_1_105_c.08427230.jpeg";